import { useState, useEffect, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useRestaurantContext } from "@/contexts/RestaurantContext";
import { toast } from "sonner";

export function useRequireCommandEntry() {
  const { activeRestaurant, refetch } = useRestaurantContext();
  const [isUpdating, setIsUpdating] = useState(false);
  
  const requireCommandEntry = activeRestaurant?.require_command_entry ?? false;
  
  const updateSetting = useCallback(async (value: boolean) => {
    if (!activeRestaurant) return false;
    
    setIsUpdating(true);
    try {
      const { error } = await supabase
        .from("restaurants")
        .update({ require_command_entry: value })
        .eq("id", activeRestaurant.id);
      
      if (error) throw error;
      
      await refetch();
      toast.success(value 
        ? "Abertura prévia de comandas ativada!" 
        : "Abertura prévia de comandas desativada!"
      );
      return true;
    } catch (error) {
      console.error("Error updating require_command_entry:", error);
      toast.error("Erro ao atualizar configuração");
      return false;
    } finally {
      setIsUpdating(false);
    }
  }, [activeRestaurant, refetch]);
  
  return {
    requireCommandEntry,
    updateSetting,
    isUpdating
  };
}
